import { ref } from 'vue';

import { useInjectCampaign } from '@/hooks/use_campaign';
import { UseActionExecuteType } from '@/models/action_base';
import { openExternalUrl } from '@/utils/open_external_url';

export const xUuid = ref<string>();

/**
 * キャンペーン情報を取得して、データをローカルに保持する
 */
export function useActionOpenExternalXShare(): UseActionExecuteType {
  const campaign = useInjectCampaign();

  return async () => {
    const textWithUuidParam = `${campaign.xShareText}\n${campaign.xShareUrl}?u=${xUuid.value}`;
    const encodedText = encodeURIComponent(textWithUuidParam);
    const uri = `https://x.com/intent/tweet?text=${encodedText}`;
    openExternalUrl(uri, false);
    return false;
  };
}
